<template>
  <div class="geo-fence-info">
    <div class="cols align-items-center">
      <table class="popup-details">
        <tr>
          <th>{{ $t('geo-fences.name') }}</th>
          <td>
            <input
                v-if="isEditMode"
                type="text"
                class="stretch"
                :value="title"
                required
                @input="onNameInput"
            />
            <span v-else class="title">{{ title }}</span>
          </td>
        </tr>
        <tr>
          <th>{{ $t('geo-fences.description') }}</th>
          <td>
            <textarea
                v-if="isEditMode"
                class="stretch"
                :value="description"
                rows="1"
                required
                @input="onDescriptionInput"
            />
            <span v-else>{{ description }}</span>
          </td>
        </tr>
        <tr>
          <th>{{ $t('geo-fences.coordinates') }}</th>
          <td>
            <button
                @click="formatCoordinatesLink(coordinates.lat, coordinates.lng)"
            >
              {{ coordinates.lat }}, {{ coordinates.lng }}
            </button>
          </td>
        </tr>
        <tr>
          <th>{{ $t('geo-fences.radius') }}</th>
          <td>{{ radius }}</td>
        </tr>
      </table>
      <div v-if="allowEdit" class="rows justify-end width-100p mt-10">
        <button
            v-if="!isEditMode"
            type="button"
            @click="$emit('edit')"
        >
          {{ $t('generic.edit') }}
        </button>
        <button
            v-if="isEditMode"
            type="button"
            class="mr-5"
            @click="$emit('cancel')"
        >
          {{ $t('generic.cancel') }}
        </button>
        <button
            v-if="isEditMode"
            type="button"
            :disabled="!isRequiredFieldsFilled"
            @click="$emit('save')"
        >
          {{ $t('generic.save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {GoogleMapsManager} from "@/assets/js/data-manipulation";

export default {
  name: 'GeoFenceInfo',
  emits: ['edit', 'save', 'cancel', 'update:title', 'update:description'],
  props: {
    title: [String],
    description: [String],
    coordinates: Object,
    radius: [Number],
    allowEdit: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isRequiredFieldsFilled() {
      return !!this.title?.trim() && !!this.description?.trim();
    },
  },
  methods: {
    onNameInput(event) {
      this.$emit('update:title', event.target.value);
    },
    onDescriptionInput(event) {
      this.$emit('update:description', event.target.value);
    },
    formatCoordinatesLink(longitude, latitude) {
      GoogleMapsManager.openLocationLink(longitude, latitude);
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
.geo-fence-info {
  background: #FFFFFF;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.07);
  border-radius: 12px;

  .title {
    font-weight: 600;
    font-size: 1rem;
    text-align: center;
    color: $default-text-color;
    line-height: 20px;
  }

  input.stretch,
  textarea.stretch {
    width: calc(100% - 24px);
  }
}
</style>